<template>
    <div>
        <div class="splide" id="dashboard-flashsale-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="k"
                        @click="clickDashboard(dashboard,k)">
                        <img class="w-full rounded-xl" :src="dashboard.imageUrl" alt="">
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
            slider: null,
            currentSliderIndex: 0,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            let configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            let params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data[0].subCampaignDetails;
                this.setSlider();
                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard,dashboard_number) {
            let tracking_label = ''
            if (dashboard.type == 'link') {
                tracking_label = dashboard_number + "|" + dashboard.url
                this.tracking.event('home_dashboard', 'click_dashboard', tracking_label);
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                tracking_label = dashboard_number + "|" + dashboard.id
                this.tracking.event('home_dashboard', 'click_dashboard', tracking_label);
                this.$router.push('/campaign/' + dashboard.id);
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-flashsale-slide', {
                    type: 'loop',
                    arrows: false,
                    nav: false,
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },

        btnNext: function() {
            let next = this.currentSliderIndex + 1;
            this.slider.go(next);
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1;
            this.slider.go(prev);
        },
    },
}
</script>
